export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14008.da11b8c3.jpg";